import {
    React,
    useState,
    useEffect,
    useParams,
    Dialog,
    DialogTitle,
    Box,
    CloseIcon,
    Divider,
    DialogActions,
    DialogContent,
    Typography,
    DataGrid,
    GridColDef,
    Dayjs,
    dayjs,
    Grid2,
    IconButton,
    ModeEditOutlineIcon,
    AddCommentIcon,
    Tooltip,
    ViewCompactAltIcon,
    CustomDataGrid
} from '../../../utils/globalImports';

import {
    SearchBar,
    CustomButton,
    useApi,
    CustomDatePicker,
    Toaster,
    validationMessages,
    CustomBackdrop
} from '../../../utils/globalImports';


interface ModalProps {
    open: boolean;  // Prop to determine if the modal is open
    onClose: () => void;  // Function to handle modal close
    instructedFeeStageID: number;
}

interface Comment {
    id?: number;
    instructedFeeStageId: number;
    createdDate: Dayjs | null;
    updatedDate: Dayjs | null;
    createdId: number;
    createdBy: string;
    updatedBy: string;
    // instructionReference?: string;
    comment: string;
}

const ViewInstructionComments: React.FC<ModalProps> = ({ open, onClose, instructedFeeStageID }) => {
    const { execute, loading } = useApi();
    const [option, setOption] = useState<any[]>([]);

    useEffect(() => {
        fetchLogComment();
    }, []);  // The empty dependency array ensures it only runs once when the component mounts


    // Fetch LogComment
    const fetchLogComment = async () => {
        const { data } = await execute<Comment[]>('get', `InstructedFeeStageLogComments/LogsByFeeStageID/${instructedFeeStageID}`);
        if (data) {
            setOption(data);
        }
    };


    const columns: GridColDef<(typeof option)[number]>[] = [

        {
            field: 'comment', headerName: 'Notes/comments', flex: 1, headerAlign: 'center',
            align: 'center',
        },
        // {
        //     field: 'updatedBy', headerName: 'Last edited  by', flex: 1, headerAlign: 'center',
        //     align: 'center',
        // },
        // {
        //     field: 'updatedDate', headerName: 'Last edited date', flex: 1, headerAlign: 'center',
        //     align: 'center',
        //     valueFormatter: (params: any) =>
        //         dayjs(params as string).format('DD-MM-YYYY HH:mm:ss'),
        // },
        {
            field: 'createdDate', headerName: 'Created date', flex: 1, headerAlign: 'center',
            align: 'center',
            valueFormatter: (params: any) =>
                dayjs(params as string).format('DD-MM-YYYY HH:mm:ss'),
        },
        {
            field: 'createdBy', headerName: 'Created by', flex: 1, headerAlign: 'center',
            align: 'center',
        },
    ];




    return (
        <>
            {/* Modal Dialog */}
            <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
                <DialogTitle
                    sx={{
                        position: 'relative',
                        color: '#1e66ab',
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                        mb: 0,
                        fontWeight: 500,
                        fontSize: '24px'
                    }}>
                    View Comments

                    <IconButton
                        color="inherit"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8, // Position the button at the right
                            top: 8,   // Position the button at the top
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <Divider></Divider>

                <DialogContent>

                    <CustomDataGrid rows={option} columns={columns} customMessage='No log records are available' ></CustomDataGrid>

                </DialogContent>
            </Dialog>
        </>
    );
}

export default ViewInstructionComments;